import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { jt, t } from 'ttag'
import { Link, useLocation } from 'react-router-dom'

import { sessionStarted, startSession, verifyMembership } from '@h2/features/auth'
import { browserHistory } from '@main/util/browserHistory'
import { Globals } from '@h2/globals'

import ActionButton from '../../../components/ActionButton'
import Form from '../../../components/form/Form'
import Field from '../../../components/form/Field'
import * as actions from '../../../actions/combineAccountActions'
import { useTitleChange } from '../../../util/hooks'

const CombineAccountsAuth = () => {
  useTitleChange(t`Find My Account`)
  const dispatch = useDispatch()
  const { postSigninURI } = useContext(Globals)
  const { pathname } = useLocation()
  const { environment, setViewMode } = useContext(Globals)
  const combineRequest = useSelector(
    state => state.combineAccounts.combineAccountsRequest
  )
  const forgotUsername = <Link to="/lookupuser">{t`Forgot Username`}</Link>
  const forgotPassword = <Link to="/resetpassword">{t`Forgot Password`}</Link>

  return (
    <div>
      <p className="title">
        {jt`If you already have an account you can enter your username and password below to combine it with this one. Combining accounts will make all of your previous career exploration and planning progress available to you here.  If you don't remember your username or password you can use the ${forgotUsername} or ${forgotPassword} features to recover them.`}
      </p>
      <Form
        model="combineAccounts.form"
        onSubmit={form =>
          dispatch(actions.combineAccountsByAuth(form)).then(({ user, membership }) => {
            if (user) {
              dispatch(startSession({ user, environment, setViewMode }))
              dispatch(
                sessionStarted({
                  inDialog: false,
                  postSigninURI,
                  pathname
                })
              )
            } else if (membership) {
              dispatch(verifyMembership(membership))
            } else {
              /*
               * If no session was started and there is no membership to accept,
               * we'll go through registration
               * which will pre-populate information from oauth and ultimately
               * require site membership
               */
              browserHistory.push('/register')
            }

            return user
          })}>
        {form => (
          <div>
            <Field
              id="name"
              label={t`Username`}
              required={true}
              largeTextInput={true}
              model="combineAccounts.form.name"
              form={form}
            />
            <Field
              id="password"
              label={t`Password`}
              required={true}
              largeTextInput={true}
              model="combineAccounts.form.password"
              type="password"
              form={form}
            />
            <div style={{ margin: '20px 0' }}>
              <ActionButton
                loading={combineRequest.loading}
                error={combineRequest.error}
                type="submit"
                className="btn btn-success pull-right">
                {t`Combine Accounts`}
              </ActionButton>
              <Link to="/combine">&lt; {t`Back to matches`}</Link>
            </div>
          </div>
        )}
      </Form>
    </div>
  )
}

export { CombineAccountsAuth }
